<template>
  <transition-group name='fade'>
    <!-- 蒙版 -->
    <div class="mask"
         key="1"
         @click="show = false"
         v-if="show"
         @touchmove.prevent>
    </div>
    <div class="pop"
         v-show="show"
         key="2">
      <div class="bg">
        <div class="centerBox">
          <img src="https://img.webloom.cn/Img/popupTitleImg.png" alt="" class="titleImg">
        </div>
        <div class="img_box">
          <div class="mainImg" v-if="imgUrl.length > 1">
            <img :src="imgUrl[0]" alt="" class="img">
            <img :src="imgUrl[1]" alt="" class="img">
          </div>
          <div class="mainImg" style="justify-content: center" v-else>
            <img :src="imgUrl[0]" alt="" class="img">
          </div>
        </div>
      </div>
      <img @click="show = false"
       class="close cursor"
       src="https://img.webloom.cn/coach/ui/common_close_white.png"
       alt="">
      <div class="btnBox">
        <div class="btn" @click="btnClick">前往查看</div>
      </div>
    </div>
  </transition-group>

</template>

<script>
export default {
  name: 'Popup',
  data () {
    return {
      show: false,
      imgUrl: '',
      title: '',
      content: '',
      btnText: ''
    }
  },
  created () {},
  methods: {
    btnClick () {
      this.click()
      this.show = false
    }
  }
}
</script>

<style lang="scss" scoped>
$width : 100vw/1920;
.bg {
  background: url("https://img.webloom.cn/Img/popupBg.png") no-repeat center 0 * $width;
  height: 670 * $width;
  width: 690 * $width;
  border-radius: 16 * $width;
  position: relative;
  box-sizing: border-box;
  padding: 32 * $width;
  .centerBox {
    //margin-top: 32 * $width;
    //margin-bottom: 32 * $width;
    width: 626 * $width;
    height: 606 * $width;
    background: url("https://img.webloom.cn/Img/popupCenterBg.png") no-repeat center 0 * $width;
    background-size:  626 * $width 606 * $width;
    .titleImg {
      padding: 43 * $width 0 0 125 * $width;
      display: block;
      width: 379 * $width;
      height: 102 * $width;
    }
  }
  .title{
    font-family: SourceHanSansCN-Heavy;
    font-size: 40 * $width;
    color: #F37544;
    letter-spacing: 0;
    font-weight: 600;
    position: absolute;
    left: 225 * $width;
    top: 116 * $width;
  }
  .start {
    display: block;
    position: absolute;
    top: 58 * $width;
    left: 74 * $width;
  }
}
// 渐变过渡
.fade-enter,
.fade-leave-active {
  opacity: 0;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.35s;
}
// 全局弹窗
.mask {
  background: rgba(0, 0, 0, 0.5);
  position: fixed;
  top: 0;
  z-index: 9999;
  width: 100%;
  height: 100%;
}
.pop {
  height: 600 * $width;
  width: 690 * $width;
  //background:linear-gradient(0deg, #FA1A3A 0%, #FF9B5F 100%);
  border-radius: 16 * $width;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 10000;
  text-align: center;
  //background-color: linear-gradient(0deg, #FA1A3A 0%, #FF9B5F 100%);
  //background:linear-gradient(0deg, #FA1A3A 0%, #FF9B5F 100%);
  .nameBox{
    margin-top: 128 * $width;
    font-family: MicrosoftYaHeiUI-Bold;
    font-size: 20 * $width;
    color: #FBD783;
    letter-spacing: 0;
    text-align: center;
    display: flex;
    justify-content: center;
    .main{
      width: 455 * $width;
      display: flex;
      justify-content: space-between;
      .item {
        width: 215 * $width;
      }
    }
  }
  .img_box{
    width: 626 * $width;
    position: absolute;
    bottom: 125 * $width;
    //margin-top: 15 * $width;
    height: 304 * $width;
    display: flex;
    justify-content: center;
    .mainImg{
      display: flex;
      justify-content: space-between;
      width: 455 * $width;
      align-items: center;
      .img{
        //height: 304 * $width;
        width: 215 * $width;
        background: #FFFFFF;
        border: 1 * $width solid #B2906E;
      }
    }
  }
  .btnbox{
    width: 690 * $width;
    display: flex;
    justify-content: center;
    position: absolute;
    bottom: 65 * $width;
    .btn{
      border: 2 * $width solid #F37544;
      //border: 2 * $width solid #FBD783;
      border-radius: 8 * $width;
      width: 120 * $width;
      height: 40 * $width;
      line-height: 40 * $width;
      font-family: MicrosoftYaHeiUI-Bold;
      font-size: 14 * $width;
      color: #F37544;
      letter-spacing: 0;
      text-align: center;
      margin-top: 20 * $width;
    }
  }
  button {
    background: #f95644;
    border-radius: 32 * $width;
    width: 180 * $width;
    height: 50 * $width;
    font-size: 18 * $width;
    color: #ffffff;
  }
  .close {
    top: -60 * $width;
    right: 32 * $width;
    position: absolute;
    display: block;
    width: 32 * $width;
    height: 32 * $width;
  }
  .btnBox {
    display: flex;
    justify-content: center;
    .btn {
      margin-top: 32 * $width;
      font-family: MicrosoftYaHeiUI, MicrosoftYaHeiUI;
      font-weight: bold;
      font-size: 16 * $width;
      color: #FFFFFF;
      line-height: 16 * $width;
      text-align: right;
      font-style: normal;
      padding: 12 * $width 38 * $width;
      background: #0B396C;
      border-radius: 8 * $width;
      cursor: pointer;
    }
  }
}
//新的证书
.popNew {
  height: 600 * $width;
  width: 690 * $width;
  border-radius: 16 * $width;
  position: fixed;
  top: 100 * $width;
  left: 50%;
  margin-left: -345 * $width;
  z-index: 20;
  text-align: center;
  .contentBox {

  }
  .btnBox {
    display: flex;
    justify-content: center;
    .btn {
      font-family: MicrosoftYaHeiUI, MicrosoftYaHeiUI;
      font-weight: bold;
      font-size: 16 * $width;
      color: #FFFFFF;
      line-height: 16 * $width;
      text-align: right;
      font-style: normal;
      padding: 12 * $width 38 * $width;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/popup/index.vue